import App from './App';
import UnauthApp from './UnauthApp';

declare global {
  interface Window {
    App: any;
    createAccountData_email: string;
    dataLayer?: Record<string, unknown>[];
  }
}

export default App;

export { UnauthApp };
